<template>
  <div class="car-block" @click="gotoVehical(item.id)">
    <div class="car-image-container">
      <img
        class="car-image"
        :src="item.photos[0]"
        onerror="this.src='https://vassstorage.blob.core.windows.net/salesraterprod/images/m_no_photo.png'"
      />
    </div>

    <div class="car-description">
      <span class="title">{{ item.name }}</span>
      <div class="mobile-only">
        <span class="bold">Miles:&nbsp;</span>
        <span>{{ item.odometer }}</span>
      </div>

      <div class="grid desktop-only">
        <div class="grid-column">
          <div class="bold">Year</div>
          <div>{{ item.year }}</div>
        </div>
        <div class="grid-column">
          <div class="bold">Miles</div>
          <div>{{ item.odometer }}</div>
        </div>
        <div class="grid-column">
          <div class="bold">Drivetrain</div>
          <div>{{ item.driveTrain }}</div>
        </div>
        <div class="grid-column">
          <div class="bold">Transmission</div>
          <div>{{ item.transmission }}</div>
        </div>
        <div class="grid-column">
          <div class="bold">Engine</div>
          <div>{{ item.engine }}</div>
        </div>
      </div>

      <div class="price-container">
        <div class="price" :style="borderStyle">
          <span>{{ price(item.offeringPrice) }}</span>
        </div>
        <button class="price-label" @click.stop="$emit('openPriceDisclaimer')">
          <i class="fas fa-info-circle"></i>
          Excludes taxes and Fees
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import priceHelper from '../../helpers/price.helper'
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    borderStyle: {
      type: Object
    },
    backUrl: {
      type: String,
      default: 'inventory'
    }
  },
  methods: {
    gotoVehical (id) {
      if (this.backUrl) {
        localStorage.setItem('inventoryBackUrl', this.backUrl)
      }
      this.$router.load({ url: `vehicle/${id}` })
    },
    price (price) {
      return priceHelper.toPrice(price)
    }
  }
}
</script>

<style scoped>
.car-block {
  display: grid;
  grid-template-columns: minmax(auto, 280px) 1fr;
  gap: 15px;
}

.mobile-only {
  display: none !important;
}

.bold {
  font-weight: bold;
}

.car-image {
  width: 100%;
  object-fit: cover;
  display: inline-block;
}

.car-description .title {
  font-size: 24px;
  font-weight: bold;
  line-height: 1;
}

.price {
  display: flex;
    align-items: center;
    justify-content: center;
  min-width: 150px;
  margin: 0;
  font-weight: bold;
  text-align: center;
  font-size: 24px;
  background-color: #f9f301;
  color: #222222;
  height: 45px;
  font-family: Source Sans Pro, "sans-serif";
}

.sort-section {
  width: 290px;
  display: inline-block;
  padding-left: 60px;
}

.sort-section span {
  font-weight: bold;
  font-size: 18px;
}

.car-image-container img {
  width: 100%;
  height: 100%;
}

.price-container {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 15px;
}

.price-label {
 color: rgba(30, 100, 177, 1);
    background-color: rgba(30, 100, 177, 0.2);
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 0.9rem;
    border: none;
}

.price-label > i {
  margin-right: 4px;
}

.grid {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  /* grid-template-columns: repeat(auto-fit, minmax(25px, auto)); */
  margin-top: 8px;
}

.grid-column {
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  flex: 0 1 auto;
}

.grid-column:last-child {
  flex-basis: 100%;
}

@media (max-width: 1249px) {
  .desktop-only {
    display: none !important;
  }

  .mobile-only {
    display: block !important;
  }

  .price-container {
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 4px;
    margin-top: 4px;
  }

  .price-label {
    padding: 2px 6px;
    font-size: 0.7rem;
  }

  .price-label > i{
    margin-right: 0;
  }

  .car-image-container {
    aspect-ratio: 4 / 3;
  }

  .mobile-block {
    display: block;
  }

  .car-block {
     grid-template-columns: minmax(auto, 50%) 1fr;
  }

  .car-description {
    font-size: 16px;
  }
}

</style>



// WEBPACK FOOTER //
// inventory-list-item.vue?f3e59ad0